<template>
  <div>
    <div
      ref="videoArea"
      class="maintainRatioTopBar bigVideo"
    >
      <div
        v-for="(videoComponent, index) in bigVideoStreams"
        ref="videoComp"
        :key="index"
        class="holder"
      >
        <div
          v-if="$parent.getActiveVideoComponentMedia(videoComponent).length > 0"
          ref="videoCompName"
          class="rounded embed-responsive embed-responsive-16by9"
        >
          <video
            v-for="(media, indexVideo) in videoComponent.media"
            :ref="'bigVideo' + indexVideo"
            :key="indexVideo"
            :src-object.prop.camel="media.media"
            :class="{ active: $parent.speaker_userId != '' && videoComponent.user && videoComponent.user.id == $parent.speaker_userId && indexVideo == 0 }"
            :style="$parent.computeVideoElementStyle(indexVideo, media)"
            autoplay="true"
            playsinline
            @loadeddata="(data) => { media.loaded = true }"
            @click="$parent.moveToFirst(videoComponent.media, media)"
            @pause="(e) => { e.target.play() }"
          />
          <div
            v-if="videoComponent.user"
            class="name-plate">
            {{ videoComponent.user.presence && videoComponent.user.presence.isModerator ? "* ": "" }} {{ videoComponent.user.firstName }} {{ videoComponent.user.lastName }}
          </div>
        </div>
        <div
          v-else
          ref="bigVideo"
          :class="{ active: $parent.speaker_userId != '' && videoComponent.user && videoComponent.user.id == $parent.speaker_userId }"
          class="rounded embed-responsive embed-responsive-16by9">
          <div
            ref="videoCompName"
            class="camera-off">
            <span
              v-if="videoComponent.user && videoComponent.user.presence && videoComponent.user.presence.isPhone"
              class="roundedAvatar"
            >
              <phone-icon :size="size"/>
            </span>
            <span
              v-else-if="videoComponent.user && videoComponent.user.presence && videoComponent.user.presence.avatar && videoComponent.user.presence.avatar != 'null'"
              class="roundedAvatar"
            >
              <img
                :src="videoComponent.user.presence.avatar"
                width="100%"
                height="auto">
            </span>
            <span
              v-else-if="videoComponent.user"
              class="roundedAvatar"
            >
              {{ videoComponent.user.firstName.charAt(0).toUpperCase() + videoComponent.user.lastName.charAt(0).toUpperCase() }}
            </span>
          </div>
          <div
            v-if="videoComponent.user"
            class="name-plate">
            {{ videoComponent.user.presence && videoComponent.user.presence.isModerator ? "* ": "" }} {{ videoComponent.user.firstName }} {{ videoComponent.user.lastName }}
          </div>
        </div>
        <aparte-icon
          v-if="videoComponent.user && videoComponent.user.presence && videoComponent.user.presence.ap != 0"
          :size="32"
          class="aparteControl"/>
        <video-component-controls
          :video-component="videoComponent"
          :meeting-controls="$parent.$parent.$refs.meetingControls"
          :index="index"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { isMobile } from "../../functions/browserDetails"
import { ref, computed, onBeforeUnmount } from "@vue/composition-api"
import VideoComponentControls from "./VideoComponentControls"
import AparteIcon from "../../icons/Aparte"
import PhoneIcon from "../../icons/Phone"
export default {
  name: 'AllVideosEveryone',
  components : {
    'video-component-controls': VideoComponentControls,
    'aparte-icon': AparteIcon,
    'phone-icon': PhoneIcon
  },
  setup(props, context) {
    const videoStreamsDisplayed = ref(0)
    const bigVideoStreams = computed(() => {
      return context.parent.videoComponents
    })
    const clientWidth = ref(0)
    const clientHeight = ref(0)
    const updater = ref({})
    const size = ref('100%')
    updater.value = setInterval(calcVideoWidth, 1000)

    onBeforeUnmount(() => {
      clearInterval(updater.value)
    })


    function canFullScreen (index) {
      return !isMobile() && (document.fullscreenEnabled)
    }

    function makeFullScreen (index) {
      context.refs.bigVideo0[index].requestFullscreen()
    }

    function isPresenceVideoAreaEmpty() {
      return context.parent.videoComponents.filter( videoComponent => context.parent.getActiveVideoComponentMedia(videoComponent).length < 1 ).length < 1
    }

    function calcVideoWidth() {
      if (context.refs.videoComp == undefined || context.refs.videoArea == undefined ||
        clientHeight.value ==  context.refs.videoArea.clientHeight &&
        clientWidth.value ==  context.refs.videoArea.clientWidth &&
        videoStreamsDisplayed.value == bigVideoStreams.value.length) {
          if (context.refs.videoComp != undefined) {
            for (let i=0; i< context.refs.videoComp.length; i++) {
              context.refs.videoCompName[i].style.fontSize = context.refs.videoComp[i].style.height.replace('px','') / 12 + 'px'
            }
          }
        return
      }
      clientHeight.value = context.refs.videoArea.clientHeight
      clientWidth.value = context.refs.videoArea.clientWidth
      videoStreamsDisplayed.value = bigVideoStreams.value.length
      let videoNum = bigVideoStreams.value.length
      let realWidth = (videoNum * (context.refs.videoArea.clientHeight / 9) * 16)
      let ratio = realWidth / context.refs.videoArea.clientWidth
      let height = context.refs.videoArea.clientHeight
      let videoHeight = context.refs.videoArea.clientHeight
      let rows = 1
      while (ratio >= 1) {
        videoHeight = 0.98 * videoHeight
        rows = Math.floor(height / videoHeight)
        realWidth = ( Math.ceil(videoNum/rows) * (videoHeight / 9) * 16 )
        ratio = realWidth / context.refs.videoArea.clientWidth
      }
      let videoCompWidth = (videoHeight/9*16)
      let videoCompInRow =  Math.floor(context.refs.videoArea.clientWidth/videoCompWidth)
      if (videoCompInRow > videoNum)
        videoCompInRow = videoNum
      let spaceInRow = context.refs.videoArea.clientWidth - (videoCompInRow * videoCompWidth)
      let margin = Math.floor(spaceInRow / videoCompInRow / 2)
      if (margin < 0) margin = 0
      for (let i=0; i< context.refs.videoComp.length; i++) {
        context.refs.videoComp[i].style.position = 'relative'
        context.refs.videoComp[i].style.height = videoHeight + 'px'
        context.refs.videoComp[i].style.width = (videoHeight/9*16) + 'px'
        context.refs.videoComp[i].style.marginLeft = margin + 'px'
        context.refs.videoComp[i].style.marginRight = margin + 'px'
        context.refs.videoCompName[i].style.fontSize = videoHeight / 12 + 'px'
      }
    }

    return {
      updater,
      size,
      bigVideoStreams,
      isPresenceVideoAreaEmpty,
      isMobile,
      canFullScreen,
      makeFullScreen,
      calcVideoWidth,
      clientWidth,
      clientHeight,
      videoStreamsDisplayed
    }
  }
}
</script>
<style scoped>
.maintainRatioTopBar{
  height: calc(100vh - 110px);
  max-width: 100%;
  margin: 0 auto;
}
.muted { background-color:#ffffff; color:#e72113; display: inline-flex; opacity: 1!important;}
.muted:hover{ background-color: #ffffff}
.tooltip { top: 0; }
.bigVideo{
  position: relative;
  z-index: 11;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: space-evenly;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoArea/AllVideosEveryone.vue